export const BIBLE_DESKTOP_WIDTH = 1100;
export const BIBLE_LARGE_WIDTH = 768;
export const BIBLE_MEDIUM_WIDTH = 500;

export const isCustomDesktop = `@media screen and (min-width: ${BIBLE_DESKTOP_WIDTH}px)`;
export const isLargeDevice = `@media screen and (min-width: ${BIBLE_LARGE_WIDTH}px) and (max-width: ${BIBLE_DESKTOP_WIDTH}px)`;
export const isMediumDevice = `@media screen and (min-width: ${BIBLE_MEDIUM_WIDTH}px) and (max-width ${BIBLE_LARGE_WIDTH}px)`;
